<div class="modal-header border-bottom-0 pb-0">
  <h5 class="modal-title fw-bold text-dark m-0" style="font-size: 18px;">{{ title }}</h5>
  <button type="button" class="btn-close shadow-none" aria-label="Close" (click)="onCancelClicked()" [disabled]="isLoading"></button>
</div>
<hr>
  <div class="modal-body px-3 pt-0">
    <p class="text-dark fw-bold mb-4" style="font-size: 14px;">
      {{ message }}
    </p>
    <div class="d-flex justify-content-between gap-3">
      <button class="btn cancel-btn flex-grow-1" (click)="onCancelClicked()" [disabled]="isLoading">
        Cancel
      </button>
      <button class="btn confirm-btn flex-grow-1" (click)="onConfirmClicked()" [disabled]="isLoading">
        {{buttonLabel}}
        @if (isLoading) {
          <fa-icon class="ms-1" size="sm" [icon]="faSpinner" [animation]="'spin'"></fa-icon>
        }
      </button>
    </div>
  </div>
